import { request } from '@/utils/request'

export interface CreateFunnel {
  name: string
  templateType: 'one_page_checkout' | 'three_pages_checkout' | 'paypal_with_upsell'
  postupsellFunnelType: 'webc' | null
  newPostupsellFlow: boolean
}

interface UpdateFunnel {
  id: string
  name: string
}

interface PostUpsell {
  id: number;
  postupsell: any;
}


export async function getFunnelList() {
  // 文档：GET /shopify-app/funnels
  return request<any>(`/shopify-app/funnels`, {
    method: 'GET',
  })
}

export async function createFunnel(params: CreateFunnel) {
  // 文档：POST /shopify-app/funnels
  return request<any>(`/shopify-app/funnels`, {
    method: 'POST',
    data: params,
  })
}

export async function updateFunnelName(params: UpdateFunnel) {
  // 文档：PUT /shopify-app/funnels/name
  return request<any>(`/shopify-app/funnels/name`, {
    method: 'PUT',
    data: params,
  })
}

export async function deleteFunnel(id: string) {
  // 文档：DELETE /shopify-app/funnels/{id}
  return request<any>(`/shopify-app/funnels/${id}`, {
    method: 'DELETE',
  })
}

export async function updateFunnelPostUpsell(params: PostUpsell) {
  // 文档：PUT /shopify-app/funnels/postupsell
  return request<any>(`/shopify-app/funnels/postupsell`, {
    method: "PUT",
    data: params,
  });
}

export async function updateFunnel(params: any) {
  // 文档：PUT /shopify-app/funnels
  return request<any>(`/shopify-app/funnels`, {
    method: "PUT",
    data: params,
  });
}

// 获取funnel详情 根据funnelId
export async function getFunnelById(id: number) {
  // 文档：GET /shopify-app/funnels/{id}
  return request<any>(`/shopify-app/funnels/${id}`, {
    method: "GET"
  });
}

/**
 * 更新 funnel 模板
 * @param params
 * @returns
 */
export async function updateFunnelTemplate(params: any) { 
    // 文档：PUT /shopify-app/funnels/{templateId}/template
    return request<any>(`/shopify-app/funnels/${params.funnel.template.id}/template`, {
    method: 'PUT',
    data: params,
  })
}